import { jsxs, jsx } from 'react/jsx-runtime';
import { CustomLink, SubTitle, styled } from '@teko/ds-desktop';
import { t } from './i18n.es.js';
import { B as BlockHeader } from './BlockHeader-4332d564.js';
import { E as EnhancedImage } from './EnhancedImage-5956213c.js';

const ListCategories = ({ header, categories, }) => {
    return (jsxs(ListCategoriesWrapper, { children: [jsx(BlockHeader, Object.assign({}, header, { title: header.title || t('Danh mục sản phẩm') }), void 0), jsx(ContentBlock, { children: categories.map((item, index) => (jsx(Item, { children: jsxs(CustomLink, Object.assign({}, item.link, { children: [jsx(EnhancedImage, Object.assign({ width: 56, height: 56, objectFit: "cover" }, item.image), void 0), jsx(SubTitle, Object.assign({ marginTop: "s8", level: 2, line: 2, weight: "regular", hoverColor: "primary500" }, { children: item.title }), void 0)] }), void 0) }, index))) }, void 0)] }, void 0));
};
const Item = styled.div `
  text-align: center;
`;
const ListCategoriesWrapper = styled.div `
  background: white;
  border-radius: 8px;
`;
const ContentBlock = styled.div `
  display: flex;
  justify-content: space-between;
  padding: 8px 16px 24px 16px;
  text-align: center;
  gap: 16px;
`;

export { ListCategories as L };
